import { useRef } from "react";
import { useDripsyTheme } from "./use-dripsy-theme";
import { css } from "./css";
import { useBreakpointIndex } from "./css/breakpoint-context";
import stableHash from "stable-hash";
export function useSx() {
    var theme = useDripsyTheme().theme;
    var breakpoint = useBreakpointIndex();
    var cache = useRef(new Map());
    return function(sx) {
        var themeKey = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).themeKey;
        var themedStyle = css(sx, breakpoint)({
            theme: theme,
            themeKey: themeKey
        });
        var hash = stableHash(themedStyle);
        if (!cache.current.has(hash)) {
            cache.current.set(hash, themedStyle);
        }
        return cache.current.get(hash);
    };
}
